import { InfoIcon } from "../../../../assets/icons"
import cx from "classnames"

import { Tooltip, tooltipPlacements } from "../../tooltip"
import styles from "./index.module.css"

export interface LabelProps {
  label: string
  id?: string
  tooltip?: string
  disabled?: boolean
  required?: boolean
}

export const Label = ({ label, id, tooltip, disabled = false, required = false }: LabelProps) => {
  const labelClasses = cx(styles.label, {
    [styles.labelDisabled]: disabled,
  })

  return (
    <label htmlFor={id} className={labelClasses}>
      {label}
      {required && <span> *</span>}
      {tooltip && (
        <span className={styles.tooltipWrapper}>
          <Tooltip placement={tooltipPlacements.TOP} text={tooltip}>
            <span className={styles.tooltipIcon}>
              <InfoIcon />
            </span>
          </Tooltip>
        </span>
      )}
    </label>
  )
}
